import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/components/layout/Layout.vue";
import LoginView from "@/views/login/LoginView.vue";
import OtpView from "@/views/login/OtpView.vue";
import ResetView from "@/views/user/ResetView.vue";
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/Otp',
        name: "OtpView",
        component:OtpView
    },
    {
        path: '/ResetView',
        name: "ResetView",
        component:ResetView
    },
    {
        path: '/project-documentation',
        name: "ProjectDocumentation",
        component: () => import('@/views/ProjectDocumentation.vue')
    },
    {
        path: '/',
        name: "login",
        component:LoginView
    },
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '/dashboard',
                name: "TransactionManager",
                meta: { requiresAuth: true },
                component: () => import('@/views/TransactionManager.vue')
            },
            {
                path: '/UserManagment',
                name: "UserManagment",
                meta: { requiresAuth: true },
                component: () => import('@/views/user/UserManagment.vue')
            },
            {
                path: '/reset-Password',
                name: "KazangResetPassword",
                meta: { requiresAuth: true },
                component: () => import('@/views/kazang/KazangResetPassword.vue')
            },
            {
                path: '/reset-initialization',
                name: "KazangInitialization",
                meta: { requiresAuth: true },
                component: () => import('@/views/kazang/KazangInitialization.vue')
            },
            {
                path: '/KazangAccountDetails',
                name: "KazangAccountDetails",
                meta: { requiresAuth: true },
                component: () => import('@/views/kazang/KazangAccountDetials.vue')
            },
            {
                // Operator utility for setting Kazang credentials directly, without
                // the OTP reset flow (TicketApp #28417). Sits alongside the OTP
                // routes rather than replacing them (Q4).
                path: '/KazangSetCredentials',
                name: "KazangSetCredentials",
                meta: { requiresAuth: true },
                component: () => import('@/views/kazang/KazangSetCredentials.vue')
            },
            {
                path: '/form-management',
                name: "FormManagement",
                meta: { requiresAuth: true },
                component: () => import('@/views/Form.vue')
            },
            {
                path: '/Settings',
                name: "Settings",
                meta: { requiresAuth: true },
                component: () => import('@/views/Settings.vue')
            },
            {
                path: '/admin/brands',
                name: "AdminBrands",
                meta: { requiresAuth: true },
                component: () => import('@/views/AdminBrands.vue')
            },
            {
                path: '/admin/locations',
                name: "AdminLocations",
                meta: { requiresAuth: true },
                component: () => import('@/views/AdminLocations.vue')
            },
            {
                path: '/admin/prices',
                name: "PriceMatrix",
                meta: { requiresAuth: true },
                component: () => import('@/views/PriceMatrix.vue')
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    // const isAuthenticated = store.getters['getCurrentUser'];
    const isAuthenticated = sessionStorage.getItem('session');
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            next('/');
        } else {
            next();
        }
    } else {
        next();
    }
});
// Auto-track page views on every successful route change.
// Uses window.usageTracker set up in GlobalVariables.js.
router.afterEach((to, from) => {
    if (window.usageTracker) {
        window.usageTracker.track('kdiy-1777981450768', {
            feature: 'page:' + (to.name || to.path),
            action: 'view'
        });
    }
});
export default router
